<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_DLSD">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ this.getLanguage["DLSR"]["MGBT"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeDLSD">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div>
                                        <CCol>
                                            <div class="custom-table-wrapper">                                                
                                                <div class="pageBtn table-header">
                                                    <button @click="ctrPageGBT(+int_Page_GBT - 1)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page_GBT"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPageGBT(+int_Page_GBT,0)" />
                                                    <span class="tableItemCount">/ {{int_TP_GBT}}</span>
                                                    <button @click="ctrPageGBT(+int_Page_GBT + 1)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>                                                    
                                                <table class="custom-table afb-blue custom-table-inPopUp">
                                                    <thead>
                                                        <tr>                                                            
                                                            <th colspan="100%">{{this.getLanguage['MTA']['FSS']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <td colspan="100%" v-if="gbtData == null || gbtData.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                        <tr v-else class='kema-eft'>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>{{this.getLanguage['MTA']['TSW']}}</td>
                                                            <td :style="renderActivityStyle(1)" :class="gbtData.BA >= 0? 'positive-number' : ''" class="tableCtnRight">{{ formatNumber(gbtData.BA, 2,gbtData.CS) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 5%;">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['PM']['GPROV']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['BI']}}
                                                            </th>

                                                            <th style="width: 20%;">
                                                                {{this.getLanguage['BETRPT']['G']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['BA']}}
                                                            </th>
                                                            <th style="width: 15%;">
                                                                {{this.getLanguage['BETRPT']['BT']}}
                                                            </th>
                                                            <th style="width: 5%;">
                                                                {{this.getLanguage['MEM']['CI']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['MEM']['TO']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['WL']}}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_trans == null || obj_trans.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_trans">
                                                        <td>{{ CountItemGbt(index+1) }}</td>
                                                        <td>{{ renderProviderName(data.PN) }}</td>
                                                        <td>{{ data.TI }}</td>

                                                        <td>{{ renderGameName(data.PN, data.GN) }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.BA, 2, data.ISOC, false) }}</td>
                                                        <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</td>
                                                        <td>{{ data.ISOC }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.TA, 2, data.ISOC, false) }}</td>
                                                        <td :class="data.WLA > 0? 'positive-number' : ''" class="tableCtnRight">{{formatNumber(data.WLA, 2,"")}}</td>                                                        
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["NO"] }}
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['RS']}}
                                                <i @click="setSortTable('RS')" class="sortlogo" :class="setSortLogo('RS')"></i>
                                            </template>
                                            <template v-else-if="header == 'GPC' && !hideBrand">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['BN']}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ISOC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CI']}}
                                                <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DLSP']['PN']}}
                                                <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['CR']['CT']}}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DLSP']['CA']}}
                                                <i @click="setSortTable('CA')" :class="setSortLogo('CA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'FS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DLSP']['NOS']}}
                                                <i @click="setSortTable('FS')" :class="setSortLogo('FS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DLSP']['SW']}}
                                                <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GPN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AG']['GP']}}
                                                <i @click="setSortTable('GPN')" :class="setSortLogo('GPN')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('DLSR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['DLSR']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" id="searchExcludeSubAgent" />
                                        <label class="searchLabel ml-1" for="searchExcludeSubAgent">{{getLanguage["GL"]["ODA"]}}</label>
                                    </div>
                                </div>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  :limitText="count => `+${count}`"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :options="dd_agentgroup"
                                                  v-model="arr_FV['AGI']"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('PM.AGI')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SAGT']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :cacheOptions="false"
                                            :load-options="loadSubBrandOptions"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            :disabled="disableSubDD || searchExcludeSubAgent"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :cacheOptions="false"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="arr_FV['MB']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['RS']}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_memberdlsstatus"
                                            :placeholder="this.utilGetDDLanguage('PM.RS')"
                                            v-model="arr_FV['RS']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['DLSP']['PN']}} :</span>
                                <CInput size="sm" v-model="arr_FV['PN']"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CI']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{this.getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency"
                                            @input="updateCC()" />
                            </div>
                            <!--<div class='searchCol'>
        <span class='searchLabel'>{{this.getLanguage["PM"]["OP"]}} :</span>
        <CInput size="sm" v-model="arr_FV['OP']"></CInput>
    </div>
    <div class='searchCol'>
        <span class='searchLabel'>{{this.getLanguage["GL"]["IP"]}} :</span>
        <CInput size="sm" v-model="arr_FV['AIP']"></CInput>
    </div>-->
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="100%">{{this.getLanguage['MTA']['DRSL']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if=" arry_Psl.length != 0" @click="bool_showSummary = !bool_showSummary" class='kema-eft'>
                            <td style="width:20%"></td>
                            <td style="width:20%"></td>
                            <td style="width:20%"></td>
                            <td style="width:20%">{{this.getLanguage['MTA']['TCA']}}</td>
                            <td style="width:20%" :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(decimal_gt+totalSpinWinning, 2, GtcurrencySyntax) }}</td>
                        </tr>
                        </tbody>
                        <thead v-if="bool_showSummary">
                            <tr>
                                <th style="width:20%">{{this.getLanguage['MTA']['C']}}</th>
                                <th style="width:20%" class="tableCtnRight">{{this.getLanguage['MTA']['TMC']}}</th>
                                <th style="width:20%" class="tableCtnRight">{{this.getLanguage['MTA']['TDC']}}</th>
                                <th class="tableCtnRight" style="width:20%">{{this.getLanguage['MTA']['TFC']}}</th>
                                <th class="tableCtnRight" style="width:20%">{{this.getLanguage['MTA']['TSW']}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="bool_showSummary">
                        <td colspan="100%" v-if=" arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in groupedData">
                            <td>{{ data.IC }} </td>
                            <td class="tableCtnRight">{{ formatNumber(data.TMC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.TDC, 0) }}</td>
                            <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.TCA, 2, data.CS) }}</td>
                            <!--Total Spin Winning-->
                            <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.BA, 2, data.CS) }} </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']['DLSRL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['RS']}}
                                        <i @click="setSortTable('RS')" class="sortlogo" :class="setSortLogo('RS')"></i>
                                    </template>
                                    <template v-else-if="header == 'GPC' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['BN']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['PN']}}
                                        <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CR']['CT']}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['CA']}}
                                        <i @click="setSortTable('CA')" :class="setSortLogo('CA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'FS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['NOS']}}
                                        <i @click="setSortTable('FS')" :class="setSortLogo('FS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['SW']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GPN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['GP']}}
                                        <i @click="setSortTable('GPN')" :class="setSortLogo('GPN')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['RS']}}
                                        <i @click="setSortTable('RS')" class="sortlogo" :class="setSortLogo('RS')"></i>
                                    </template>
                                    <template v-else-if="header == 'GPC' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['BN']}}
                                        <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['PN']}}
                                        <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CR']['CT']}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['CA']}}
                                        <i @click="setSortTable('CA')" :class="setSortLogo('CA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'FS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['NOS']}}
                                        <i @click="setSortTable('FS')" :class="setSortLogo('FS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['SW']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GPN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['GP']}}
                                        <i @click="setSortTable('GPN')" :class="setSortLogo('GPN')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_DLSReportList == null">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_DLSReportList" :class="data.MS == 1? 'blacklist-row': ''">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'RS'">
                                    {{ renderStatus(data.RS) }}
                                </template>
                                <template v-else-if="header == 'GPC' && !hideBrand">
                                    <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                    <span class="saggroupname" v-if="data.SAGPC != ''">{{ data.SAGGN }} ({{ data.SAGPC }})</span>
                                </template>
                                <template v-else-if="header == 'ISOC'">
                                    {{ data.ISOC }}
                                </template>
                                <template v-else-if="header == 'U'">
                                    <span class="grid-line" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AAGI,data.MI)">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)" style="text-align: center;z-index: 100;font-size: 11px;position: absolute;right: 0px;top: 0px;height: 17px;">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span class="grid-line" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)">{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)" style="text-align: center;z-index: 100;font-size: 11px;position: absolute;right: 0px;top: 0px;height: 17px;">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>

                                <template v-else-if="header == 'PN'">
                                    {{ data.PN }}
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    {{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'CA'">
                                    <span v-if="data.PG == 1" class="grid-line tableCtnRight">{{formatNumber(data.CA, 2,data.CS)}}</span>
                                    <span v-else class="grid-line tableCtnRight">-</span>
                                </template>
                                <!--Number of Free Spin-->
                                <template v-else-if="header == 'FS'">
                                    <span v-if="data.PG == 2" class="grid-line" @click="viewDLSDetail(data)">
                                        {{ data.FS }}
                                        <div class="float-right ml-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span v-else class="grid-line">-</span>
                                </template>
                                <template v-else-if="header == 'BA'">
                                    <!--Spin Winning-->
                                    <span v-if="data.PG == 2" class="grid-line tableCtnRight">{{formatNumber(data.BA, 2,data.CS)}}</span>
                                    <span v-else class="grid-line tableCtnRight">-</span>
                                </template>
                                <template v-else-if="header == 'GPN'">
                                    <span v-if="data.PG == 2" class="grid-line">{{ renderProviderName(data.GPN) }}</span>
                                    <span v-else class="grid-line">-</span>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import { constDLSStatus, constAccessType, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },

        data() {
            return {
                bool_DLSD: false, // dls details
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,
                bool_showSearchBar: true,
                ddCurrencyList: null,
                searchCurrency: null,
                bool_isSearchCC: false,
                GtcurrencySyntax: 'USD',
                arr_FV: {
                    "MB": null,
                    "DR": {
                        startDate: this.getYesterdayStartDate(),
                        endDate: this.getMonthEndDate()
                    },
                    "RS": ["2", "4", "5"],
                    "PN": "",
                    "AGI": null,
                    "AGI_csv": null,
                    "SAGAGI": null,
                    "CI": null,
                },
                arr_DLSReportList: [],
                dd_memberdlsstatus: [],
                dd_agentgroup: [],
                dd_subagentgroup: [],
                ddDefaultSubBrand: [],
                rtSubBrand: 0,
                ddMemberList: [],
                dd_currency: [],
                arry_Psl: [],
                obj_trans: [],
                constAccessType: constAccessType,
                hideBrand: false,
                arry_vdp: [],
                searchVDP: null,
                disableSubDD: false,
                defaultReportHeaders: ['NO', 'RS', 'GPC', 'ISOC', 'U', 'PN', 'CTS', 'CA', 'FS', 'BA', 'GPN'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                int_TP_GBT: 1,
                int_Page_GBT: 1,
                int_RC_GBT: 50,
                int_IC_GBT: 1,
                gbtData: null,
                searchExcludeSubAgent: false
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
            groupedData() {
                return this.arry_Psl.reduce((acc, currentItem) => {
                    const groupKey = currentItem.IC;
                    if (!acc[groupKey]) {
                        acc[groupKey] = {
                            IC: groupKey,
                            TMC: 0,
                            TDC: 0,
                            TCA: 0,
                            BA: 0
                        };
                    }
                    acc[groupKey].TMC += currentItem.TMC;
                    acc[groupKey].TDC += currentItem.TDC;
                    acc[groupKey].TCA += currentItem.TCA;
                    acc[groupKey].BA += currentItem.BA;
                    acc[groupKey].CS = currentItem.CS;
                    return acc;
                }, {});
            },
        },
        methods: {
            loadCurrencyOptions() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                            that.str_showDetails = (that.str_showDetails ? that.str_showDetails : that.ddCurrencyList[i].label);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                        }

                    });
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);
                }
            },
            renderGameName(providerName, gameName) {
                if (providerName in this.getLanguage && gameName in this.getLanguage[providerName])
                    return this.getLanguage[providerName][gameName];

                return gameName;
            },
            viewDLSDetail(dlsData) {
                this.gbtData = dlsData;
                this.obj_trans = [];                
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page_GBT, this.int_RC_GBT, "CTS", true);

                if (path) {
                    path += "&";
                }

                path += ("f.D=" + dlsData.BC +
                    "&f.mi=" + dlsData.MI +
                    "&f.GPI=" + dlsData.GPI);

                if (this.searchCurrency) {
                    path += "&f.CICI=" + this.searchCurrency;
                } else if (localStorage.getItem('CCUSD') != "") {
                    path += "&f.CICI=" + localStorage.getItem('CCUSD');
                }

                this.getDataApi(`/api/dlspromo/lr/trans?${path}`,
                    function (data) {                        
                        that.int_TP_GBT = Math.max(data.D.TotalPages, 1);
                        that.obj_trans = data.D.Items;
                        that.bool_DLSD = true;
                        that.bool_fullLoading = false;
                    });

            },
            closeDLSD() {
                this.bool_DLSD = !this.bool_DLSD;                
                this.gbtData = null;
                this.int_IC_GBT = 1; 
                this.int_Page_GBT = 1;
                this.int_TP_GBT = 1;                         
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            getVDP() {
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
                this.dd_memberdlsstatus = [{
                    id: "2",
                    label: this.getLanguage['DLSR']['S2']
                },
                {
                    id: "4",
                    label: this.getLanguage['DLSR']['S4']
                },
                {
                    id: "5",
                    label: this.getLanguage['DLSR']['S5']
                }
                ];
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getDLSReportList();
            },
            ctrPageGBT(newPage, inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_Page_GBT = Math.max(1, Math.min(newPage, this.int_TP_GBT));
                }
                else {
                    this.int_Page_GBT = (newPage > this.int_TP_GBT) ? 1 : (newPage < 1) ? this.int_TP_GBT : newPage;
                }
                this.int_IC_GBT = this.int_Page_GBT;

                if (this.gbtData != null) {
                    this.viewDLSDetail(this.gbtData);
                }
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.arr_FV.DR) {
                    if (this.arr_FV.DR.startDate != "") {
                        var z = this.set90daysDateSearch(this.arr_FV.DR.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                if (this.searchCurrency != null) {
                    this.bool_isSearchCC = true;
                } else {
                    this.bool_isSearchCC = false;
                }
                this.getDLSReportList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            CountItemGbt(value) {
                if (this.int_IC_GBT != 1) {
                    return value + ((this.int_IC_GBT - 1) * this.int_RC_GBT);
                } else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getDLSReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getDropdownList() {
                var that = this;

                
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                            //var cloneParentGroup = that.deepClone(d.dropdownlist);

                            ////// list filter only push in child group, do not include own group
                            //if (cloneParentGroup != null && cloneParentGroup.length > 0) {
                            //    that.dd_agentgroup = [];
                            //    for (var i = 0; i < cloneParentGroup.length; i++) {
                            //        for (var j = 0; j < cloneParentGroup[i].children.length; j++) {
                            //            that.dd_agentgroup.push(cloneParentGroup[i].children[j]);
                            //        }
                            //    }
                            //}
                        }
                    });
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = "";
                    if (this.arr_FV["SAGAGI"]) {
                        agi = this.arr_FV["SAGAGI"];
                    } else if (this.arr_FV["AGI_csv"]) {
                        agi = this.arr_FV["AGI_csv"];
                    }

                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.arr_FV['AGI_csv']) {
                    parentAGI = this.arr_FV["AGI_csv"];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.arr_FV['SAGAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getDLSReportList();
                    });
            },
            AgentGroupChangefs(value) {
                this.disableSubDD = false;
                this.arr_FV['AGI_csv'] = null;
                this.arr_FV['SAGAGI'] = null;
                if (value != undefined) {
                    //var agi = 0;
                    if (value != "") {
                        //agi = value.split("-")[1];
                        var temp = "";
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.arr_FV["AGI_csv"] = temp;
                        this.searchPAgi = this.arr_FV["AGI_csv"];
                        this.arr_FV['SAGAGI'] = null;
                        if (value.length > 1) {
                            this.disableSubDD = true;
                        }
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.arr_FV['AGI_csv'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();
                //else {
                //    this.arr_FV['AGI'] = null;
                //    this.arr_FV['SAGAGI'] = null;
                //}
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                        this.arr_FV["SAGAGI"] = agi;
                    }
                }
                else {
                    this.arr_FV['SAGAGI'] = null;
                }
            },
            getDLSReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    var encodedSearchPromotionName = "";
                    if (this.arr_FV["PN"] != null) {
                        encodedSearchPromotionName = encodeURIComponent(this.arr_FV["PN"]);
                    }

                    path += (
                        "f.MI=" + (this.arr_FV["MB"] == null ? "" : this.arr_FV["MB"]) +
                        "&f.PN=" + (encodedSearchPromotionName)
                        //"&f.RS=" + (this.arr_FV["RS"] == null ? "" : this.arr_FV["RS"]) +
                        //"&f.PN=" + (this.arr_FV["PN"] == null ? "" : this.arr_FV["PN"]) 
                        //"&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"])
                        //"&f.OP=" + (this.arr_FV["OP"] == null ? "" : this.arr_FV["OP"]) +
                        //"&f.AIP=" + (this.arr_FV["AIP"] == null ? "" : this.arr_FV["AIP"])
                    );

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.PTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.PTS_to=" + cts_to;
                    }

                    if (this.arr_FV["CI"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CI.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CI[x];
                        }
                        path += ("&f.CI_csv=" + temp_);
                    }

                    if (this.arr_FV["RS"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.RS.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.RS[x];
                        }
                        path += ("&f.RS_in=" + temp_);
                    }

                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.ATAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : "4-" + this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                }
                if (this.searchCurrency) {
                    path += "&f.CICI=" + this.searchCurrency;
                } else if (localStorage.getItem('CCUSD') != "") {
                    path += "&f.CICI=" + localStorage.getItem('CCUSD');
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (!this.arr_FV["SAGAGI"] && this.searchExcludeSubAgent) {
                    path += "&f.SAGI=0";
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }
                this.getDataApi(`/api/dlspromo/lr?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_DLSReportList = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
                this.getDataApi(`/api/dlspromo/lr/total?${path}`,
                    function (data) {                        
                        that.setDLSSummaryList(data);
                    });

            },
            setDLSSummaryList(data) {                
                this.arry_Psl = data;
                this.decimal_gt = 0;
                this.totalSpinWinning = 0;
                if (this.arry_Psl.length != 0) {
                    for (var i = 0; i < this.arry_Psl.length; i++) {
                        this.decimal_gt += this.arry_Psl[i].GT;
                        this.totalSpinWinning += this.arry_Psl[i].TBA;
                    }
                }
                this.GtcurrencySyntax = 'USD';
                if (this.arry_Psl.length != 0 && (this.bool_isSearchCC || localStorage.getItem('CCUSD') != ""))
                {
                    this.GtcurrencySyntax  = this.arry_Psl[0].CS;
                }
            },

            renderStatus(statusCode) {
                return this.getLanguage['DLSR']['S' + statusCode];
            },
            //renderRejectReason(rejectReason) {
            //    const found = constRejectReasonP.some(el => el.id === rejectReason);

            //    if (found) {
            //        for (var d of constRejectReasonP) {
            //            if (d.id == rejectReason) {
            //                rejectReason = d.label;
            //            }
            //        }
            //    }

            //    return rejectReason;
            //},
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }

            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: this.getYesterdayStartDate(),
                    endDate: this.getMonthEndDate()
                };
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        "f.MI=" + (this.arr_FV["MB"] == null ? "" : this.arr_FV["MB"]) +
                        //"&f.RS=" + (this.arr_FV["RS"] == null ? "" : this.arr_FV["RS"]) +
                        "&f.PN=" + (this.arr_FV["PN"] == null ? "" : this.arr_FV["PN"]) 
                        //"&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"])
                        //"&f.OP=" + (this.arr_FV["OP"] == null ? "" : this.arr_FV["OP"]) +
                        //"&f.AIP=" + (this.arr_FV["AIP"] == null ? "" : this.arr_FV["AIP"])
                    );

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.PTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.PTS_to=" + cts_to;
                    }

                    if (this.arr_FV["CI"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CI.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CI[x];
                        }
                        path += ("&f.CI_csv=" + temp_);
                    }

                    if (this.arr_FV["RS"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.RS.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.RS[x];
                        }
                        path += ("&f.RS_in=" + temp_);
                    }

                    if (this.searchCurrency) {
                        path += "&f.CICI=" + this.searchCurrency;
                    } else if (localStorage.getItem('CCUSD') != "") {
                        path += "&f.CICI=" + localStorage.getItem('CCUSD');
                    }

                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.ATAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : "4-" + this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                }
                console.log(this.arr_FV["AGI_csv"]);
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (!this.arr_FV["SAGAGI"] && this.searchExcludeSubAgent) {
                    path += "&f.SAGI=0";
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }
                window.open('/api/dlspromo/dlsexcel?' + path, '_blank');
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            resetColumn(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn('GPC')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            renderClassName(header, data) {
                if (header == 'U') {
                    return " kema-eft";
                } else if (header == 'FS') {
                    return "tableCtnRight kema-eft";
                }
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS4';
            this.$parent.showActiveMenu = 'R.DLSR';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.arr_FV.AGI = this.$route.query.agi;            
            this.arr_FV.PN = this.$route.query.pc;
            this.loadCurrencyOptions();
            if (this.$route.query.agi !== undefined && this.$route.query.agi !== null) {
                this.getDropdownList(true);
                var split = this.$route.query.agi.split("-");
                if (split.length == 2) {
                    this.arr_FV.AGI_csv = split[1];
                }
                else {
                    this.arr_FV.AGI_csv = split[0];
                }
                this.arr_FV.AGI = ["3-" + this.arr_FV.AGI_csv];
                this.AgentGroupChangefs(this.arr_FV.AGI);

                if (this.$route.query.sagi !== undefined && this.$route.query.sagi !== null && this.$route.query.sagi != 0) {
                    this.arr_FV.SAGAGI = this.$route.query.sagi;
                    this.loadDefaultSubBrand(this.arr_FV.SAGAGI);
                }
            }
            else {
                this.getDropdownList(false);
                this.getDLSReportList();
            }

            if (this.$route.query.ci) {
                this.arr_FV.CI = [];
                this.arr_FV.CI.push(this.$route.query.ci);
            }            
            if (this.$route.query.df) {
                this.arr_FV.DR.startDate = this.$route.query.df;
            }
            if (this.$route.query.dt) {
                this.arr_FV.DR.endDate = this.$route.query.dt;
            }
            if (this.$route.query.pc) {
                this.arr_FV.DR.startDate = this.$route.query.df;
                this.arr_FV.DR.endDate = this.$route.query.dt;
            }
            if (this.$route.query.pn) {
                this.arr_FV.PN = this.$route.query.pn;
            }

            this.getDropdownList();
            this.getCurrencyList();
            this.getVDP();
            if (this.getUserInfo.AT == 4)
                this.loadDefaultSubBrand(0);
            if (this.$route.path != this.$route.fullPath) 
                this.getDLSReportList();            
        },
        watch: {
            getLanguage() {
                this.getDLSReportList();
                this.getVDP();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/DLSReport`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                if (that.hideBrand) {
                                    that.removeDefaultColumn('GPC')
                                    that.removeColumn('GPC')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/DLSReport/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/DLSReport.vue